// @ts-check

/** Storefront origin (no trailing slash), set per environment via REACT_APP_STOREFRONT_URL. Empty when unset. */
export const STOREFRONT_URL = (process.env.REACT_APP_STOREFRONT_URL || '').replace(/\/+$/, '');
